import * as tslib_1 from "tslib";
import { PaymentTemplate } from '../../modules/payments/classes/payment-template.class';
var TokenizeTemplate = /** @class */ (function (_super) {
    tslib_1.__extends(TokenizeTemplate, _super);
    function TokenizeTemplate() {
        return _super.call(this) || this;
    }
    TokenizeTemplate.prototype.onTranslations = function (translations) {
        this.title = translations['payment-add-card'];
        this.description = translations['payment-add-card-description'];
    };
    return TokenizeTemplate;
}(PaymentTemplate));
export { TokenizeTemplate };
